import { memo } from "react";

interface GroupedReaction {
  emoji: string;
  count: number;
  hasUserReacted: boolean;
}

interface MessageReactionsProps {
  reactions: GroupedReaction[];
  onToggleReaction: (emoji: string) => void;
  isOwnMessage: boolean;
}

const MessageReactions = memo(({ reactions, onToggleReaction, isOwnMessage }: MessageReactionsProps) => {
  if (reactions.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1 mt-1 ${isOwnMessage ? "justify-end" : "justify-start"}`}>
      {reactions.map((reaction) => (
        <button
          key={reaction.emoji}
          onClick={() => onToggleReaction(reaction.emoji)}
          className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs transition-colors ${
            reaction.hasUserReacted
              ? "bg-pop/20 border border-pop"
              : "bg-muted/50 border border-transparent hover:border-muted-foreground/30"
          }`}
        >
          <span>{reaction.emoji}</span>
          {reaction.count > 1 && (
            <span className="text-muted-foreground">{reaction.count}</span>
          )}
        </button>
      ))}
    </div>
  );
});

MessageReactions.displayName = "MessageReactions";

export default MessageReactions;
